import React, { ReactNode } from 'react';
import { Sidebar } from 'components/Sidebar';
import { Navbar } from 'components/Navbar';
import { NavbarLink } from 'components/NavbarLink';
import { AdminRoutes } from 'shared/Routes';
import { isAdminSubscriptionsEnabled } from 'shared/featureFlags';

interface IProps {
  children?: ReactNode | ReactNode[];
  match?: any;
}

export const AdminSidebar: React.FC<IProps> = ({ children, match }: IProps) => {

  return (
    <div id='wrapper'>
      <Sidebar>

        <NavbarLink label='Dashboard' active faIcon='tachometer-alt' route={AdminRoutes.HOME} />

        <hr className="sidebar-divider" />
        <NavbarLink label='Users' active faIcon='user' route={AdminRoutes.USERS} />
        {isAdminSubscriptionsEnabled && (
          <NavbarLink label='Subscriptions' active faIcon='credit-card' route={AdminRoutes.SUBSCRIPTIONS} />
        )}
        <NavbarLink label='App Config' active faIcon='cogs' route={AdminRoutes.APP_CONFIG} />
        <NavbarLink label='Feed Posts' active faIcon='video' route={AdminRoutes.FEED_POSTS} />
        <NavbarLink label='Teams' active faIcon='magnet' route={AdminRoutes.TEAMS} />
        <NavbarLink label='Live Streams' active faIcon='stream' route={AdminRoutes.LIVE_STREAMS} />
        <NavbarLink label='Pro Teams' active faIcon='futbol' route={AdminRoutes.PRO_TEAMS} />

      </Sidebar>

      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <Navbar match={match} />

          <div className="container-fluid">
            {children}
          </div>
        </div>
      </div>
    </div >
  )
}
